import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeSVG } from '../../../../assets/svgIcons';

import Tab from '../components/Tab';
import Dropdown from '../components/Dropdown';
import LocationInput from './Inputs/LocationInput';
import { markerSmallSVG } from '../../../../assets/svgIcons';

import { updateFilters } from '../../../reducers/filtersSlice';

const Location = () => {
  const { collection: filtersCollection } = useSelector((state) => state.filters);
  const { zones } = filtersCollection
  const dispatch = useDispatch();

  const onPlaceSelected = (zone) => {
    const zoneObject = {
      class: zone.type,
      id: zone.id,
      displayedName: zone.display_name
    };
    
    const isAlreadySelected = zones?.some(z => z.class === zoneObject.class && z.id === zoneObject.id && z.displayedName === zoneObject.displayedName);
    if (isAlreadySelected) return;
    
    const updatedZones = [...(zones || []), zoneObject];
    dispatch(updateFilters({
      ...filtersCollection,
      zones: updatedZones
    }));
  }

  const removeSelectedOption = (e, zoneToRemove) => {
    e.stopPropagation();
    dispatch(updateFilters({
      ...filtersCollection,
      zones: zones.filter(z => !(z.class === zoneToRemove.class && z.id === zoneToRemove.id && z.displayedName === zoneToRemove.displayedName))
    }));
  };

  return(
    <div className='vesta-dropdown-filter-container'>
      <Tab name='Localisation' tab='location' />

      <Dropdown title='Où recherchez-vous ?' tab='location'>
        <div className='vesta-location-input'>
          <div className='vesta-relative-position'>
            <div className='vesta-marker'>
              {markerSmallSVG('#5076F6')}
            </div>

            <LocationInput
              onPlaceSelected={onPlaceSelected}
            />
          </div>

          {zones?.length > 0 && (
            <div className='vesta-flex-row-start vesta-gap-10 vesta-flex-wrap vesta-margin-t-10'>
              {
                zones.map((zone, index) => {
                  return (
                    <div key={`${zone.class}-${zone.id}`}
                         className='vesta-autocomplete-label vesta-blue-100 vesta-flex-row-center vesta-gap-10 typo-input vesta-cursor-pointer' 
                         onClick={(e) => removeSelectedOption(e, zone)}>
                      {zone.displayedName}{closeSVG('#5076F6')}
                    </div>
                  )
                })
              }
            </div>
          )}
        </div>
      </Dropdown>
    </div>
  )
};

export default Location;
